var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.956 0V57.674H413.545L312.156 159.063C279.612 134.919 239.319 120.632 195.685 120.632C87.611 120.632 0 208.242 0 316.316C0 424.389 87.611 512 195.684 512C303.757 512 391.368 424.389 391.368 316.316C391.368 272.682 377.081 232.388 352.937 199.844L454.326 98.456V235.045H512V0H276.956ZM195.684 447.552C123.204 447.552 64.447 388.795 64.447 316.315C64.447 243.835 123.204 185.078 195.684 185.078C268.164 185.078 326.921 243.835 326.921 316.315C326.921 388.796 268.164 447.552 195.684 447.552Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/Male.53232c29a5c2da3a0e776ac21ec295bd.svg";
export { ForwardRef as ReactComponent };